/**
 * Element checklist: which required categories are NOT covered by a moodboard's
 * items. Returns the missing categories in the required list's order. Advisory
 * only — the caller renders a hint, it never blocks.
 */
export function missingCategories(itemCategories: string[], requiredCategories: string[]): string[] {
  const present = new Set(itemCategories);
  return requiredCategories.filter((c) => !present.has(c));
}
